var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"content",staticClass:"position-relative"},[_vm._t("content"),(_vm.hasRequest && !_vm.deleteSpinner)?_c('div',{staticClass:"d-flex align-items-center justify-content-center mt-1",class:{ horizontal: _vm.isHorizontal }},[_c('b-spinner')],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }